import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { getCurrentHour } from '../../resource-management.tools'

const { Option } = Select
const START = 'START'
const END = 'END'
const HOURS = Array.from(Array(25).keys())

const TimesDropdown = (props) => {
  const { t } = useTranslation()
  const { timeTable, setTimeTable, timeNum, type, disableHours } = props
  const [currentHour, setCurrenHour] = useState()

  const handleSelect = (value) => {
    setTimeTable([
      ...timeTable.slice(0, timeNum),
      type === START ? { ...timeTable[timeNum], start: value } : { ...timeTable[timeNum], end: value },
      ...timeTable.slice(timeNum + 1)
    ])
  }

  useEffect(() => {
    setCurrenHour(getCurrentHour())
  }, [])

  const getHourText = (hour) => {
    const time = 12
    if (type === END) {
      const endHour = hour - 1
      return `${endHour === 0 ? time : endHour <= time ? endHour : endHour - time}:59`
    }
    return `${hour === 0 ? time : hour <= time ? hour : hour - time}:00`
  }

  const isDisableHour = (hour) => {
    if (type !== START) {
      return timeTable[timeNum].start >= hour
    } else if (timeNum > 0) {
      for (let idx = 0; idx < timeNum; idx++) {
        if (timeTable[idx].end > hour) {
          return true
        }
      }
    } else if (type === START && disableHours) {
      return hour < currentHour
    }
  }

  const isDisableSelect = () => {
    if (type !== START) {
      return timeTable[timeNum].start === ''
    } else if (timeNum > 0) {
      for (let idx = 0; idx < timeNum; idx++) {
        if (timeTable[idx].start === '' || timeTable[idx].end === '') {
          return true
        }
      }
    }
  }

  const hoursToPrint = type === START ? HOURS.slice(0, 24) : HOURS.slice(1, 25)
  return (
    <Select disabled={isDisableSelect()} defaultValue={t('jobs.timeline.resources.select')} onChange={handleSelect}>
      {hoursToPrint.map((hour, i) => {
        return (
          <Option key={`hour-${i}`} value={hour} disabled={isDisableHour(hour)}>
            {`${getHourText(hour)} ${hour <= 12 ? 'AM' : 'PM'}`}
          </Option>
        )
      })}
    </Select>
  )
}

export default TimesDropdown
